import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Loader } from "../../packages/shared";
import { COUNTRY_LIST } from "../../utils";
import { GET_ALL_TIERS } from "./query";
import { SectionTitle } from "../shared";

const TierCountryList = () => {
    const currentUser = useSelector((state) => state.users.currentUser);
    const [countryList, setCountryList] = useState(currentUser.country);

    const { loading, data } = useQuery(gql(GET_ALL_TIERS));

    useEffect(() => {
        if (currentUser.userType === 99 && data) {
            if (data?.allAllerganProTiers?.nodes.length > 0) {
                setCountryList([
                    ...new Set(data?.allAllerganProTiers?.nodes.map((item) => item.country)),
                ]);
            }
        } else if (currentUser.userType === 1) {
            const matchedCountries = data?.allAllerganProTiers?.nodes
                .filter((tier) => currentUser.country.includes(tier.country))
                .map((tier) => tier.country);

            setCountryList([...new Set(matchedCountries)]);
        }

        return () => {
            setCountryList([]);
        };
    }, [data, currentUser]);

    return (
        <>
            {loading && <Loader />}

            <SectionTitle
                title={"Tier Country List"}
                buttonUrl={`/allergan-pro/tier/create`}
                backUrl={"/allergan-pro"}
            />

            <div className="accordion mt-5" id="accordionTierCountryList">
                <div className="card">
                    <div className="card-header">
                        <button
                            className="btn btn-block btn-link font-weight-bold text-decoration-none text-left"
                            type="button"
                        >
                            Country List
                        </button>
                    </div>
                </div>

                {!loading && countryList && countryList.length > 0 ? (
                    countryList.map((country, index) => {
                        return (
                            <div key={index} className="card">
                                <div className="card-header">
                                    <Link
                                        key={country}
                                        className="btn btn-block btn-link font-weight-bold text-decoration-none text-left text-body"
                                        to={`/allergan-pro/tier/${country}`}
                                    >
                                        {COUNTRY_LIST[country]}
                                    </Link>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="card">
                        <div className="card-body">
                            {!loading && (
                                <p className="font-weight-normal text-danger">
                                    No country permission found!!!
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default TierCountryList;
